<template>
	<div id="page">
		<div class="page-content">
			<div class="page-title page-title-small">
				<h2>
					<!--<button @click.prevent="goBack"><i class="fa fa-arrow-right"></i></button>-->
					راهنما
				</h2>
				<button class="bg-fade-gray1-dark shadow-xl d-flex align-items-center justify-content-center refresh-btn" @click.prevent="reloadPage"><i class="font-16 fa fa-redo"></i></button>
				<button data-menu="menu-main" class="bg-fade-gray1-dark shadow-xl d-flex align-items-center justify-content-center menu-main-btn"><i class="fa fa-bars"></i></button>
			</div>
			<div class="card header-card shape-rounded" data-card-height="100">
				<div class="card-overlay bg-highlight opacity-95"></div>
				<div class="card-overlay dark-mode-tint"></div>
			</div>
			<div class="card card-style">
				<div class="content mb-2">

					<div class="list-group list-custom-small">
						<div class="list-group-div" data-menu="instant-1">
							<i class="font-14 far fa-star color-yellow1-dark mt-2"></i>
							<b class="xsmob">معرفی اپلیکیشن تسکینو</b>
							<i class="fa fa-angle-left"></i>
						</div>

						<div class="list-group-div" data-menu="instant-7">
							<i class="font-14 fa fa-download color-brown1-dark mt-2"></i>
							<b class="xsmob">نصب و راه اندازی اپلیکیشن تسکینو</b>
							<i class="fa fa-angle-left"></i>
						</div>
						<div class="list-group-div" data-menu="instant-2">
							<i class="font-14 fa fa-check color-magenta2-dark mt-2"></i>
							<b class="xsmob">ثبت وظیفه</b>
							<i class="fa fa-angle-left"></i>
						</div>
						<div class="list-group-div" data-menu="instant-9">
							<i class="font-14 fa fa-check-circle color-magenta2-light mt-2"></i>
							<b class="xsmob">ثبت نوع وظیفه</b>
							<i class="fa fa-angle-left"></i>
						</div>
						<div class="list-group-div" data-menu="instant-10">
							<i class="font-14 fa fa-check-square color-red2-light mt-2"></i>
							<b class="xsmob">چرخه وظیفه</b>
							<i class="fa fa-angle-left"></i>
						</div>
						<div class="list-group-div" data-menu="instant-3">
							<i class="font-14 far fa-check-circle color-green1-dark mt-2"></i>
							<b class="xsmob">ثبت فعالیت</b>
							<i class="fa fa-angle-left"></i>
						</div>
						<div class="list-group-div" data-menu="instant-4">
							<i class="font-14 far fa-check-square color-pink2 mt-2"></i>
							<b class="xsmob">ثبت پیگیری</b>
							<i class="fa fa-angle-left"></i>
						</div>
						<div class="list-group-div" data-menu="instant-5">
							<i class="font-14 fa fa-bell color-blue1-light mt-2"></i>
							<b class="xsmob">ثبت یادآور</b>
							<i class="fa fa-angle-left"></i>
						</div>
						<div class="list-group-div" data-menu="instant-6">
							<i class="font-14 fa fa-times color-red1-light mt-2"></i>
							<b class="xsmob">کارتابل درخواست ها</b>
							<i class="fa fa-angle-left"></i>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div id="instant-1" class="menu menu-box-right" data-menu-width="100%" data-menu-effect="menu-over">
			<div class="position-relative">
				<button @click="pauseVid('video1')" class="close-menu"><i class="fa fa-times text-white font-26"></i></button>
				<div class="card" data-card-height="90">
					<div class="card-top">
						<div class="page-title page-title-small">
							<h2 class="text-right helpTitle">معرفی اپلیکیشن تسکینو</h2>
						</div>
					</div>
					<div class="card-overlay bg-highlight opacity-95"></div>
					<div class="card-overlay dark-mode-tint"></div>
					<div class="card-bg bg-20"></div>
				</div>
				<div class="d-flex justify-content-center">
					<video class="responsive-video" controls id="video1" preload="none" poster="/assets/images/taskAppHelpVideoPoster.jpg">
						<source src="https://dssnovinit.com/Content/Upload/Video/tskMobileAppHelp/Taskino-mobile-app-intro.mp4" type="video/mp4">
					</video>
				</div>

				<a href="https://dssnovinit.com/Content/Upload/Video/tskMobileAppHelp/Taskino-mobile-app-intro.mp4" download target="_blank" class="btn btn-m btn-full bg-highlight rounded-m font-900 mt-3 mx-3">دانلود</a>
			</div>
		</div>

		<div id="instant-7" class="menu menu-box-right" data-menu-width="100%" data-menu-effect="menu-over">
			<div class="position-relative">
				<button @click="pauseVid('video7')" class="close-menu"><i class="fa fa-times text-white font-26"></i></button>
				<div class="card" data-card-height="90">
					<div class="card-top">
						<div class="page-title page-title-small">
							<h2 class="text-right helpTitle">نصب و راه اندازی اپلیکیشن تسکینو</h2>
						</div>
					</div>
					<div class="card-overlay bg-highlight opacity-95"></div>
					<div class="card-overlay dark-mode-tint"></div>
					<div class="card-bg bg-20"></div>
				</div>
				<div class="d-flex justify-content-center">
					<video class="responsive-video" controls id="video7" preload="none" poster="/assets/images/taskAppHelpVideoPoster2.jpg">
						<source src="https://dssnovinit.com/Content/Upload/Video/tskMobileAppHelp/taskApp-install.mp4" type="video/mp4">
					</video>
				</div>

				<a href="https://dssnovinit.com/Content/Upload/Video/tskMobileAppHelp/taskApp-install.mp4" download target="_blank" class="btn btn-m btn-full bg-highlight rounded-m font-900 mt-3 mx-3">دانلود</a>
			</div>
		</div>
		<div id="instant-2" class="menu menu-box-right" data-menu-width="100%" data-menu-effect="menu-over">
			<div class="position-relative">
				<button @click="pauseVid('video2')" class="close-menu"><i class="fa fa-times text-white font-26"></i></button>
				<div class="card" data-card-height="90">
					<div class="card-top">
						<div class="page-title page-title-small">
							<h2 class="text-right helpTitle">راهنمای ثبت وظیفه</h2>
						</div>
					</div>
					<div class="card-overlay bg-highlight opacity-95"></div>
					<div class="card-overlay dark-mode-tint"></div>
					<div class="card-bg bg-20"></div>
				</div>
				<div class="d-flex justify-content-center">
					<video class="responsive-video" controls id="video2" preload="none" poster="/assets/images/taskAppHelpVideoPoster.jpg">
						<source src="https://dssnovinit.com/Content/Upload/Video/tskMobileAppHelp/CreateTask.mp4" type="video/mp4">
					</video>
				</div>
				<a href="https://dssnovinit.com/Content/Upload/Video/tskMobileAppHelp/CreateTask.mp4" download target="_blank" class="btn btn-m btn-full bg-highlight rounded-m font-900 mt-3 mx-3">دانلود</a>

			</div>
		</div>

		<div id="instant-9" class="menu menu-box-right" data-menu-width="100%" data-menu-effect="menu-over">
			<div class="position-relative">
				<button @click="pauseVid('video9')" class="close-menu"><i class="fa fa-times text-white font-26"></i></button>
				<div class="card" data-card-height="90">
					<div class="card-top">
						<div class="page-title page-title-small">
							<h2 class="text-right helpTitle">راهنمای ثبت نوع وظیفه</h2>
						</div>
					</div>
					<div class="card-overlay bg-highlight opacity-95"></div>
					<div class="card-overlay dark-mode-tint"></div>
					<div class="card-bg bg-20"></div>
				</div>
				<div class="d-flex justify-content-center">
					<video class="responsive-video" controls id="video9" preload="none" poster="/assets/images/taskAppHelpVideoPoster.jpg">
						<source src="https://dssnovinit.com/Content/Upload/Video/tskMobileAppHelp/CreateTaskType.mp4" type="video/mp4">
					</video>
				</div>
				<a href="https://dssnovinit.com/Content/Upload/Video/tskMobileAppHelp/CreateTaskType.mp4" download target="_blank" class="btn btn-m btn-full bg-highlight rounded-m font-900 mt-3 mx-3">دانلود</a>

			</div>
		</div>
		<div id="instant-10" class="menu menu-box-right" data-menu-width="100%" data-menu-effect="menu-over">
			<div class="position-relative">
				<button @click="pauseVid('video10')" class="close-menu"><i class="fa fa-times text-white font-26"></i></button>
				<div class="card" data-card-height="90">
					<div class="card-top">
						<div class="page-title page-title-small">
							<h2 class="text-right helpTitle">راهنمای چرخه وظیفه</h2>
						</div>
					</div>
					<div class="card-overlay bg-highlight opacity-95"></div>
					<div class="card-overlay dark-mode-tint"></div>
					<div class="card-bg bg-20"></div>
				</div>
				<div class="d-flex justify-content-center">
					<video class="responsive-video" controls id="video10" preload="none" poster="/assets/images/taskAppHelpVideoPoster.jpg">
						<source src="https://dssnovinit.com/Content/Upload/Video/tskMobileAppHelp/TaskAll.mp4" type="video/mp4">
					</video>
				</div>
				<a href="https://dssnovinit.com/Content/Upload/Video/tskMobileAppHelp/TaskAll.mp4" download target="_blank" class="btn btn-m btn-full bg-highlight rounded-m font-900 mt-3 mx-3">دانلود</a>

			</div>
		</div>
		<div id="instant-3" class="menu menu-box-right" data-menu-width="100%" data-menu-effect="menu-over">
			<div class="position-relative">
				<button @click="pauseVid('video3')" class="close-menu"><i class="fa fa-times text-white font-26"></i></button>
				<div class="card" data-card-height="90">
					<div class="card-top">

						<div class="page-title page-title-small">
							<h2 class="text-right helpTitle">راهنمای ثبت فعالیت</h2>
						</div>
					</div>
					<div class="card-overlay bg-highlight opacity-95"></div>
					<div class="card-overlay dark-mode-tint"></div>
					<div class="card-bg bg-20"></div>
				</div>
				<div class="d-flex justify-content-center">
					<video class="responsive-video" controls id="video3" preload="none" poster="/assets/images/taskAppHelpVideoPoster.jpg">
						<source src="https://dssnovinit.com/Content/Upload/Video/tskMobileAppHelp/add-otherWork.mp4" type="video/mp4">
					</video>
				</div>
				<a href="https://dssnovinit.com/Content/Upload/Video/tskMobileAppHelp/add-otherWork.mp4" download target="_blank" class="btn btn-m btn-full bg-highlight rounded-m font-900 mt-3 mx-3">دانلود</a>

			</div>
		</div>

		<div id="instant-4" class="menu menu-box-right" data-menu-width="100%" data-menu-effect="menu-over">
			<div class="position-relative">
				<button @click="pauseVid('video4')" class="close-menu"><i class="fa fa-times text-white font-26"></i></button>
				<div class="card" data-card-height="90">
					<div class="card-top">
						<div class="page-title page-title-small">
							<h2 class="text-right helpTitle">راهنمای ثبت پیگیری</h2>
						</div>
					</div>
					<div class="card-overlay bg-highlight opacity-95"></div>
					<div class="card-overlay dark-mode-tint"></div>
					<div class="card-bg bg-20"></div>
				</div>
				<div class="d-flex justify-content-center">
					<video class="responsive-video" controls id="video4" preload="none" poster="/assets/images/taskAppHelpVideoPoster.jpg">
						<source src="https://dssnovinit.com/Content/Upload/Video/tskMobileAppHelp/add-taskWork.mp4" type="video/mp4">
					</video>
				</div>
				<a href="https://dssnovinit.com/Content/Upload/Video/tskMobileAppHelp/add-taskWork.mp4" download target="_blank" class="btn btn-m btn-full bg-highlight rounded-m font-900 mt-3 mx-3">دانلود</a>

			</div>
		</div>


		<div id="instant-5" class="menu menu-box-right" data-menu-width="100%" data-menu-effect="menu-over">
			<div class="position-relative">
				<button @click="pauseVid('video5')" class="close-menu"><i class="fa fa-times text-white font-26"></i></button>
				<div class="card" data-card-height="90">
					<div class="card-top">
						<div class="page-title page-title-small">
							<h2 class="text-right helpTitle">راهنمای ثبت یادآور</h2>
						</div>
					</div>
					<div class="card-overlay bg-highlight opacity-95"></div>
					<div class="card-overlay dark-mode-tint"></div>
					<div class="card-bg bg-20"></div>
				</div>
				<div class="d-flex justify-content-center">
					<video class="responsive-video" controls id="video5" preload="none" poster="/assets/images/taskAppHelpVideoPoster.jpg">
						<source src="https://dssnovinit.com/Content/Upload/Video/tskMobileAppHelp/add-riminder.mp4" type="video/mp4">
					</video>
				</div>
				<a href="https://dssnovinit.com/Content/Upload/Video/tskMobileAppHelp/add-riminder.mp4" download target="_blank" class="btn btn-m btn-full bg-highlight rounded-m font-900 mt-3 mx-3">دانلود</a>

			</div>
		</div>

		<div id="instant-6" class="menu menu-box-right" data-menu-width="100%" data-menu-effect="menu-over">
			<div class="position-relative">
				<button @click="pauseVid('video6')" class="close-menu"><i class="fa fa-times text-white font-26"></i></button>
				<div class="card" data-card-height="90">
					<div class="card-top">
						<div class="page-title page-title-small">
							<h2 class="text-right helpTitle">راهنمای کارتابل درخواست ها</h2>
						</div>
					</div>
					<div class="card-overlay bg-highlight opacity-95"></div>
					<div class="card-overlay dark-mode-tint"></div>
					<div class="card-bg bg-20"></div>
				</div>
				<div class="d-flex justify-content-center">
					<video class="responsive-video" controls id="video6" preload="none" poster="/assets/images/taskAppHelpVideoPoster.jpg">
						<source src="https://dssnovinit.com/Content/Upload/Video/tskMobileAppHelp/close-task.mp4" type="video/mp4">
					</video>
				</div>
				<a href="https://dssnovinit.com/Content/Upload/Video/tskMobileAppHelp/close-task.mp4" download target="_blank" class="btn btn-m btn-full bg-highlight rounded-m font-900 mt-3 mx-3">دانلود</a>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				info: null
			}
		},
		methods: {
			pauseVid(id) {
				console.log(id);
				if (id != null) {
					console.log("pause");
					var vid = document.getElementById(id);
					vid.pause();
				}
			},


		},
		mounted() {
			document.querySelectorAll(".menu-box-right").forEach(a => a.style.display = "block");
		}
	}
</script>